import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    AddressFormatter,
    CurrencyFormatter,
    EmailFormatter,
    remoteComponentFormatter, remoteOptionFormatter,
    TelnumFormatter
} from "../../../utils/formatters";
import {componentFilter, optionFilter} from "../../../utils/filters";

class ShippingServiceList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, pageSize, onLoadCompleted} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: pageSize || 5, formId: this.props.formId, onLoadCompleted};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "shippingList"}
                {...props}
                columns={{
                    "shipping.tracking_id": {
                        header: 'Követési kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "shipping.contact": {
                        header: 'Kapcsolattartó',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "shipping.telnum": {
                        header: 'Telefonszám',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: TelnumFormatter
                    },
                    "shipping.email": {
                        header: 'Email',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: EmailFormatter
                    },
                    "shipping.serviceprovider_type": {
                        header: 'Szállító',
                        width: 1,
                        sortable,
                        filterable: componentFilter({component: "ShippingServiceProvider", labelfield: "methodname"}),
                        renderer: (value) => <div className="nowrap">{remoteComponentFormatter({component: "ShippingServiceProvider", labelfield: "methodname"})(value)}</div>
                    },
                    "state": {
                        header: 'Státusz',
                        width: 1,
                        sortable,
                        filterable: optionFilter("shippingstate"),
                        renderer: remoteOptionFormatter("shippingstate")
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default ShippingServiceList;
